import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelect(props) {
  const [selectedData, setData] = React.useState([]);

  const handleChange = (event) => {
    setData(event.target.value);
  };

  React.useEffect(() => {
    if (props.selectedData) setData(props.selectedData);
  }, [props.selectedData]);

  React.useEffect(() => {
    props.callBack(selectedData);
  });

  return (
    <>
      <InputLabel id="demo-mutiple-checkbox-label">{props.label}</InputLabel>
      <Select
        labelId="demo-mutiple-checkbox-label"
        id="demo-mutiple-checkbox"
        multiple
        value={selectedData}
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) => { return selected.join(', '); }}
        MenuProps={MenuProps}
      >
        {props.selectionData && props.selectionData.map((name) => {
          return (
            <MenuItem key={name} value={name}>
              <Checkbox checked={selectedData.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
}
